import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["message"];

  static values = {
    url: String,
    interval: { type: Number, default: 5000 },
    maxPolls: { type: Number, default: 120 },
  };

  connect() {
    this.polls = 0;
    this.schedule();
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  schedule() {
    this.timer = setTimeout(() => this.poll(), this.intervalValue);
  }

  async poll() {
    this.polls += 1;
    if (this.polls > this.maxPollsValue) {
      this.messageTarget.textContent = "Still working. Refresh in a few minutes.";
      return;
    }

    try {
      const response = await get(this.urlValue, { responseKind: "json" });
      if (!this.element.isConnected) return;

      if (response.redirected || (response.statusCode >= 400 && response.statusCode < 500)) {
        window.location.reload();
        return;
      }

      if (response.ok) {
        const data = await response.json;
        if (!data.in_progress) {
          window.location.reload();
          return;
        }
      }
    } catch (error) {
      console.error("Error fetching transcript status:", error);
    }

    if (this.element.isConnected) this.schedule();
  }
}
